import styled from 'styled-components';
import { getSpacingToken, getToken } from '@optimus-web/common';

export const DrawerContentContainer = styled.div`
    width: 100%;
    height: 100%;
    background: ${getToken('backgroundStaticFlat')};
    display: grid;
    grid-template-rows: max-content;
    overflow-y: auto;
    padding: ${getSpacingToken('0')}px ${getSpacingToken('200')}px ${getSpacingToken('100')}px
        ${getSpacingToken('200')}px;
`;

export const DrawerSmartResultContentContainer = styled.div`
    width: 100%;
    height: 100%;
    background: ${getToken('backgroundStaticFlat')};
    display: grid;
    grid-template-rows: min-content max-content;
    overflow-y: auto;
    padding: ${getSpacingToken('0')}px ${getSpacingToken('200')}px ${getSpacingToken('100')}px
        ${getSpacingToken('200')}px;
`;
